var $checkoutAddressForm = $(".js-checkout_address_form");

$(function(){
    isSubmitAdress = false;

    if($checkoutAddressForm.find(".js-submit").val() == 1){
        formMsgBlockShowHide($checkoutAddressForm.find(".js-form_successblock"), 5000);
    }

    $checkoutAddressForm.find(".js-from_submit").on("click", function(event){
        event.preventDefault();

        var selectedOptionLief = $(".js-checkout_step_2_lief_select").find("option:selected").val();
        if(selectedOptionLief == "rech"){
            checkoutFillLiefFromRech();
        }

        if(isSubmitAdress && typeof isSubmitAdress != "undefined") return false;
        $currentButton = $(this);
        $currentButton.addClass("button_disabled")
        isSubmitAdress = true;

        var validSubmit = true;
        var errorCount = 0;

        $.each($checkoutAddressForm.find(".js-form_input"), function(key, value){
            validInput = checkInput($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        $checkoutAddressForm.find(".js-form_checkbox").each(function(){
            validInput = checkCheckbox($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        if(validSubmit){
            showLoader();

            $.ajax({
                url:$(this).data("ajax"),
                data: $checkoutAddressForm.serialize(),
                type:"POST",
                dataType: "json",
            }).done(function(response){
                $currentButton.removeClass("button_disabled")
                isSubmitAdress = false;

                if(response.errors == ""){
                    $checkoutAddressForm.trigger('submit');
                }else{
                    var errorCount = 0;

                    $.each(response.errors, function(key, value){
                        var $field = $("[name=" + value + "]");
                        var $label = $field.siblings(".js-form_label");

                        // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
                        var label_text = $field.attr("label_text");
                        if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $field.attr("placeholder");

                        $label.addClass("form_label_text-error");
                        $label.text(label_text + " - " + $field.attr("title"));
                        errorCount++;
                    });
                    formMsgBlockShow($checkoutAddressForm.find(".js-form_errorblock"));
                }

                hideLoader();
            });
        }else{
            $currentButton.removeClass("button_disabled")
            isSubmitAdress = false;
            formMsgBlockShow($checkoutAddressForm.find(".js-form_errorblock"));
            hideLoader();
        }
    });
});